import { schema } from 'normalizr'

export const googleLocationSchema = new schema.Entity('googleLocations', undefined, { idAttribute: 'place_id' })
